import React from 'react';
import { Typography } from '@mui/material';
import { FileData } from 'API';
import { format as formatDate, parseISO } from 'date-fns';

interface Props {
  file?: FileData;
}

const FileExpirationDate: React.FC<Props> = ({ file }: Props) => {
  if (!file?.expirationDate) {
    return null;
  }

  return (
    <Typography variant="caption" component="div">
      {'Exp. Date: '}
      {formatDate(parseISO(file.expirationDate), 'M/d/yyyy')}
    </Typography>
  );
};

export default FileExpirationDate;
